// Escudos de los equipos de Segunda División de Fútbol Sala (temporada 2025/26).
// Imágenes descargadas y recomprimidas (WebP, ~1-2 KB cada una) a partir de
// las miniaturas públicas de solo-futsal.es (red de sitios basada en
// admin.asturfutsal.es). Se sirven en local para no depender de un tercero
// y para garantizar que carguen rápido pese a verse muy pequeñas.
const BASE = "/img/team-logos";

const TEAM_LOGO_ENTRIES = [
  { file: "union-africa-ceuti.webp", match: ["unión áfrica", "union africa", "ceutí", "ceuti"] },
  { file: "inagroup-el-ejido.webp", match: ["el ejido"] },
  { file: "wanapix-sala-10.webp", match: ["sala 10"] },
  { file: "zambu-pinatar.webp", match: ["pinatar"] },
  { file: "heredia-malaga.webp", match: ["heredia", "malaga", "málaga"] },
  { file: "mrb-mostoles.webp", match: ["mostoles", "móstoles"] },
  { file: "entrerrios.webp", match: ["entrerrios", "entrerríos"] },
  { file: "gasifred-atletico.webp", match: ["gasifred"] },
  { file: "barca-atletic.webp", match: ["barca atletic", "barça atlètic", "barça atletic"] },
  { file: "leganes.webp", match: ["leganes", "leganés"] },
  { file: "sala5-martorell.webp", match: ["martorell"] },
  { file: "reyco-burela.webp", match: ["burela"] },
  { file: "levante.webp", match: ["levante"] },
  { file: "melistar.webp", match: ["melistar"] },
  { file: "avanza-jaen.webp", match: ["jaen", "jaén", "avanza"] },
  { file: "vulcanizados-ruiz-tafa.webp", match: ["vulcanizados", "ruiz tafa"] },
];

const normalize = (s = "") =>
  s
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

export const getLocalTeamLogo = (teamName) => {
  if (!teamName) return null;
  const n = normalize(teamName);
  const entry = TEAM_LOGO_ENTRIES.find(({ match }) =>
    match.some((m) => n.includes(normalize(m)))
  );
  return entry ? `${BASE}/${entry.file}` : null;
};
